import { Lobby } from "@/proto/Lobby";

// These activities send the per-deposit locked reward in money, not a wallet balance.
export function getRechargeLockedFunReward(
  data: Lobby.Lobby.IBalanceChangeNotifyMc
): number | undefined {
  if (
    (data.tradeModeCode !== "DAY_RECHARGE_REBATE" &&
      data.tradeModeCode !== "FIRST_RECHARGE_REBATE") ||
    data.currencyType !== "FUN" ||
    Number(data.changedMoney) !== 0
  ) {
    return undefined;
  }

  const amount = Number(data.money);
  return Number.isFinite(amount) && amount >= 0 ? amount : undefined;
}
